module.exports = "<div class=\"non-invasive-web-style-framework\">\n  <router-view :db=\"db\"></router-view>\n</div>";